/**
 * Copyright (c) 2025, CYBRA Corp. All rights reserved.
 */
export class GtinValidationSetDetail {
  id: number;
  headerId: number;
  gtin14: string;
  minPercentage: number;
  maxPercentage:number;
  createTs: Date;
  modifiedTs: Date;
}